import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {take} from "rxjs";
import {BackOfficeConfig} from "../interfaces/back-office-config";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  targetStorage: string = 'fleetConfig';
  culture: string | null = null;


  constructor(private http: HttpClient) {
  }

  initializeConfig(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      // TODO understand if to redirect in the absence of culture to the country selector (if any ;) )

      let urlSegments = window.location.pathname.split('/')
      urlSegments.shift()
      if (urlSegments.length && urlSegments[0] === '') {
        urlSegments[0] = 'en-US'
      }

      const culture = urlSegments[0];
      let url = '';

      switch (process.env['BO_ENV']){
        case 'local':
          url = `http://localhost:3000/getConfig/${culture}`;
          break
        case 'bucket':
          url = `/fakeoffice/config/${culture}.json`;
          break
        case 'backoffice':
          url = `https://media-integ.space.awsmpsa.com/uploads/FLEET/config/${culture}.json`;
          break
        case 'backoffice-prod':
          url = `https://media.space.awsmpsa.com/uploads/FLEET/config/${culture}.json`;
          break
        default:
          url = `http://localhost:3000/getConfig/${culture}`;
          break
      }
      this.http.get(url).pipe(take(1)).subscribe((value) => {
        localStorage.setItem(this.targetStorage, JSON.stringify(value));
        resolve(true);
      });
    })
  }

  getSelectedCulture(): string {
    let BOConfig: BackOfficeConfig = {} as BackOfficeConfig
    const storage = localStorage.getItem(this.targetStorage)
    if (storage != null) {
      BOConfig = JSON.parse(storage);
    }
    if (BOConfig && BOConfig['BACKOFFICE_CONFIG'] && BOConfig['BACKOFFICE_CONFIG']['CULTURE']) return BOConfig['BACKOFFICE_CONFIG']['CULTURE'];
    return '';
  }


  getLanguage(): string {
    const culture = this.getSelectedCulture();
    if (!culture) return '';
    const lang = culture.split('-')[0];
    return lang.toLowerCase();
  }

  getCountry(): string {
    const culture = this.getSelectedCulture();
    if (!culture) return '';
    const parts = culture.split('-');
    if (parts.length < 2) return '';
    return parts[1].toLowerCase();
  }

  getBackOfficeConfig(): BackOfficeConfig {
    let BOConfig: BackOfficeConfig = {} as BackOfficeConfig
    const storage = localStorage.getItem(this.targetStorage)
    if (storage != null) {
      BOConfig = JSON.parse(storage);
    }
    return BOConfig;
  }

  getVehicleLimit(): number {
    let BOConfig: BackOfficeConfig = {} as BackOfficeConfig
    const storage = localStorage.getItem(this.targetStorage)
    if (storage != null) {
      BOConfig = JSON.parse(storage);
    }
    return BOConfig.VEHICLE_LIMIT ? BOConfig.VEHICLE_LIMIT : 50;
  }
}
